export default __webpack_public_path__ + "static/media/bg-portal-updates.924fda3f.png";